export default "__VITE_ASSET__MjX3P$4m__"